const React = require('react');
const { string, arrayOf, shape } = require('prop-types');

const { FILTERS_IDS } = require('@pages/V2/utils/constants');
const { buildUrl } = require('@pages/V2/utils/clientUtils');

const PriceInputsFilter = require('./priceInputsFilter');

const ListFilter = ({ id: filterId, name: filterName, values, actualLocation, siteId, filterPosition }) => {
  return (
    <div className="list-filter">
      <p className="list-filter__title">{filterName}</p>
      <ol className="list-filter__values-list">
        {values.map(({ id, name = '', results = '' }) => {
          const hrefUrl = buildUrl({ actualLocation, filterId, filterValueId: id, filterPosition });

          return (
            <li key={id}>
              <a className="list-filter__list-element" href={hrefUrl}>
                {name} {results && <span className="quantity">({results})</span>}
              </a>
            </li>
          );
        })}
      </ol>
      {filterId === FILTERS_IDS.PRICE && (
        <PriceInputsFilter actualLocation={actualLocation} siteId={siteId} filterPosition={filterPosition} />
      )}
    </div>
  );
};

ListFilter.propTypes = {
  id: string.isRequired,
  name: string.isRequired,
  values: arrayOf(
    shape({
      id: string.isRequired,
      name: string,
      results: string,
    }),
  ),
  actualLocation: string,
};

ListFilter.defaultProps = {
  values: [],
  actualLocation: '',
};

module.exports = ListFilter;
